import { render, staticRenderFns } from "./MessageListMessageInline.vue?vue&type=template&id=4e10efe4&scoped=true&functional=true&"
import script from "./MessageListMessageInline.vue?vue&type=script&lang=js&"
export * from "./MessageListMessageInline.vue?vue&type=script&lang=js&"
import style0 from "./MessageListMessageInline.vue?vue&type=style&index=0&id=4e10efe4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "4e10efe4",
  null
  
)

export default component.exports